import type { ReactNode } from "react";

import { m } from "~/paraglide/messages";

interface ActivationLabelProps {
  active: boolean;
  children: ReactNode;
}

const ActivationLabel: React.FC<ActivationLabelProps> = ({ active, children }) => (
  <label className="gap-2.5 flex w-full items-center justify-between">
    <span className="font-normal text-base italic">{m.activation({ activation: active ? "true" : "false" })}</span>
    {children}
  </label>
);

ActivationLabel.displayName = "ActivationLabel";

export { ActivationLabel };
